import { InboxNotification } from '@novu/js';

import { NovuNotificationType } from '@shared/enum/novu-notification-type';
import { NovuNotificationModel } from '@shared/model/novu-notification-model';

export class NovuNotificationMapper {
  public static mapToModel(notification: InboxNotification): NovuNotificationModel {
    return NovuNotificationModel.build()
      .withId(notification.id)
      .withSubject(notification.subject)
      .withBody(notification.body)
      .withCreatedAt(new Date(notification.createdAt))
      .withIsRead(notification.isRead)
      .withIsSeen(notification.isSeen)
      .withIsArchived(notification.isArchived)
      .withRedirectUrl(notification.redirect?.url)
      .withSeverity(notification.severity)
      .withType(this.mapType(notification.data?.['type']))
      .withAvatar(notification.avatar)
      .withPrimaryAction(notification.primaryAction)
      .withSecondaryAction(notification.secondaryAction)
      .withTags(notification.tags);
  }

  // El payload schema del workflow define `type` como enum (INFO/SUCCESS/WARNING/
  // ERROR/QUESTION/ALERT), pero Novu solo expone las variables custom del payload
  // en `data` como `Record<string, unknown>` sin tipar: hay que validar el valor
  // antes de confiar en él.
  private static mapType(value: unknown): NovuNotificationType | undefined {
    return typeof value === 'string' && (Object.values(NovuNotificationType) as string[]).includes(value)
      ? (value as NovuNotificationType)
      : undefined;
  }
}
